module.exports = __webpack_public_path__ + "img/horizontal_4_3_6005.9c3d8e1d.png";